/* Narpine collection v2 — swatch image swap + hover quick add */
(function(){
  function card(el){ return el.closest('.product-item'); }

  /* --- colour swatch: swap the card image --- */
  document.addEventListener('click',function(e){
    var sw=e.target.closest&&e.target.closest('.np-swatch');
    if(!sw) return;
    e.preventDefault(); e.stopPropagation();
    var c=card(sw); if(!c) return;
    c.querySelectorAll('.np-swatch').forEach(function(s){ s.classList.remove('is-active'); });
    sw.classList.add('is-active');
    c.setAttribute('data-np-color', sw.getAttribute('data-np-color')||'');
    var src=sw.getAttribute('data-np-img');
    if(src){
      c.querySelectorAll('.product-item__bg img, .product-item__image img').forEach(function(img){
        img.removeAttribute('srcset'); img.removeAttribute('data-srcset');
        img.setAttribute('src',src);
      });
    }
  },true);

  /* --- hover quick add: pick size, add selected colour+size --- */
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('.np-quick__size');
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    var c=card(btn); if(!c) return;
    var wrap=btn.closest('[data-np-quick]');
    var vs; try{ vs=JSON.parse(wrap.getAttribute('data-np-variants')); }catch(err){ return; }
    var size=btn.getAttribute('data-np-size');
    var colour=c.getAttribute('data-np-color');
    if(!colour){
      var act=c.querySelector('.np-swatch.is-active');
      colour=act?act.getAttribute('data-np-color'):null;
    }
    var match=vs.find(function(v){
      var o=v.options||[];
      var okSize=o.indexOf(size)>-1;
      var okColour=colour?o.indexOf(colour)>-1:true;
      return okSize&&okColour;
    });
    if(!match){ btn.classList.add('is-oos'); setTimeout(function(){btn.classList.remove('is-oos');},1200); return; }
    if(match.available===false){ btn.classList.add('is-oos'); setTimeout(function(){btn.classList.remove('is-oos');},1200); return; }
    btn.classList.add('is-loading');
    fetch('/cart/add.js',{method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:match.id,quantity:1}]}),credentials:'same-origin'})
      .then(function(r){return r.json();})
      .then(function(){
        btn.classList.remove('is-loading');
        closeSheets();                       /* capture-phase stopPropagation kills
                                                the separate bubble listener */
        if(window.__npSyncCartCount) window.__npSyncCartCount();
        var d=document.querySelector('#cart-drawer');
        var reload=window.__npCartReload;
        if(reload){ reload(true).then(function(){ openDrawer(d); }); }
        else { openDrawer(d); }
      })
      .catch(function(){ btn.classList.remove('is-loading'); });
  },true);

  function openDrawer(d){
    if(!d) return;
    var ov=document.querySelector('#np-cart-overlay');
    if(!ov){
      ov=document.createElement('div'); ov.id='np-cart-overlay';
      document.body.appendChild(ov);
      ov.addEventListener('click',function(){ d.classList.remove('is-open'); ov.classList.remove('is-on'); });
    }
    ov.classList.add('is-on');
    d.classList.add('is-open');
    document.dispatchEvent(new CustomEvent('theme:cart:open'));
  }

  /* --- touch: quick-add opens a bottom sheet --- */
  function isTouch(){ return window.matchMedia('(hover: none)').matches; }
  function closeSheets(){
    document.querySelectorAll('.np-quick.is-open').forEach(function(q){ q.classList.remove('is-open'); });
    document.body.classList.remove('np-sheet-open');
    var bd=document.querySelector('#np-sheet-backdrop'); if(bd) bd.classList.remove('is-on');
  }
  document.addEventListener('click',function(e){
    var open=e.target.closest&&e.target.closest('[data-np-quick-open]');
    if(open){
      e.preventDefault(); e.stopPropagation();
      var c=open.closest('.product-item');
      var panel=c&&c.querySelector('.np-quick');
      if(!panel) return;
      closeSheets();
      panel.classList.add('is-open');
      /* backdrop + scroll lock are for the mobile bottom sheet only */
      if(isTouch()){
        document.body.classList.add('np-sheet-open');
        var bd=document.querySelector('#np-sheet-backdrop');
        if(!bd){ bd=document.createElement('div'); bd.id='np-sheet-backdrop';
          document.body.appendChild(bd); bd.addEventListener('click',closeSheets); }
        bd.classList.add('is-on');
      }
      return;
    }
    if(e.target.closest&&e.target.closest('[data-np-quick-close]')){ e.preventDefault(); closeSheets(); }
  },true);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeSheets(); });


  /* desktop: click outside the open panel closes it */
  document.addEventListener('click',function(e){
    if(isTouch()) return;
    var open=document.querySelector('.np-quick.is-open');
    if(!open) return;
    if(e.target.closest&&(e.target.closest('.np-quick')||e.target.closest('[data-np-quick-open]'))) return;
    closeSheets();
  },false);

})();